import React, { useContext } from 'react';
import { translations } from 'src/constants/translations';
import {
  GroupWrapperFiltersAction,
} from 'src/components/profileComponents/Marketplace/components/GroupWrapperActions/GroupWrapperFiltersAction';
import { GroupWrapper } from 'src/components/profileComponents/Marketplace/components/GroupWrapper';
import {
  GroupWrapperCollapseState,
} from 'src/components/profileComponents/Marketplace/components/GroupWrapperActions/GroupWrapperFiltersAction/types';
import { MarketplaceSwitch } from 'src/components/profileComponents/Marketplace/components/Common/MarketplaceSwitch';
import Box from '@mui/material/Box';
import { BoxFormTextField } from 'src/components/profileComponents/FormTextField';
import { SubGroupWrapper } from 'src/components/profileComponents/Marketplace/components/SubGroupWrapper';
import {
  useStyles as mainUseStyles,
} from 'src/components/profileComponents/Marketplace/components/UnitsTiles/components/Common/styles';
import {
  UnitsDataContext,
} from 'src/components/profileComponents/Marketplace/components/UnitsTiles/context/UnitsDataProvider';
import { updateTranslatedField } from 'src/components/profileComponents/Marketplace/components/Filters/helpers';

export const UnitsCardFooterHoverDetails: React.FC = () => {
  const mainStyles = mainUseStyles();
  const context = useContext(UnitsDataContext);
  const lang = context?.state.marketplace.language;
  const [collapseState, setCollapseState] = React.useState<GroupWrapperCollapseState>(GroupWrapperCollapseState.OPEN);

  return (
    <>
      <GroupWrapper
        name={translations.unitsCardFooterHoverDetails}
        actions={(
          <GroupWrapperFiltersAction
            collapseState={collapseState}
            onCollapse={(state) => {
              setCollapseState(state);
            }}
          />
      )}
      />
      { collapseState === GroupWrapperCollapseState.OPEN && lang && (
        <Box display="flex" flexDirection="column" gap="16px">
          <SubGroupWrapper
            name="Footer - hover - details"
            customOffsetStyles={mainStyles.customOffsetStyles}
            onDrag={false}
          >
            <Box display="flex" flex="auto" gap="20px">
              <MarketplaceSwitch
                title="Off/On"
                defaultChecked={context?.state.unitsCard.footer.hoverState.details.isActive}
                onChange={(checked) => {
                  if (context) {
                    context.updateState((current) => ({ ...current, unitsCard: { ...current.unitsCard, footer: { ...current.unitsCard.footer, hoverState: { ...current.unitsCard.footer.hoverState, details: { ...current.unitsCard.footer.hoverState.details, isActive: checked } } } } }));
                  }
                }}
              />
              <BoxFormTextField
                label={translations.detailsButtonName}
                defaultValue={context?.state.unitsCard.footer.hoverState.details.name?.[lang]}
                onChange={(event) => {
                  if (context) {
                    context.updateState((current) => ({
                      ...current,
                      unitsCard: {
                        ...current.unitsCard,
                        footer: {
                          ...current.unitsCard.footer,
                          hoverState: {
                            ...current.unitsCard.footer.hoverState,
                            details: updateTranslatedField(current.unitsCard.footer.hoverState.details, 'name', lang, event.target.value),
                          },
                        },
                      },
                    }));
                  }
                }}
              />
            </Box>
          </SubGroupWrapper>
        </Box>
      ) }
    </>
  );
};
